import { Settings } from 'luxon';
import { Datetime } from 'vue-datetime';
import '../../node_modules/vue-datetime/dist/vue-datetime.min.css'
require('../../sass/components/_formField.scss');
require('../../sass/components/_vue-datepicker.scss');

Settings.defaultLocale = 'pl';

export const Datepicker = {
    name: 'Datepicker',
    components: {
      Datetime
    },
    data() {
        return {
            id: 'field_' + Math.random(),
            focused: false
        }
    },
    props: ['value', 'placeholder'],
    watch: {
        value() {
            this.$emit('input', this.value);
        }
    },
    computed: {
        rootClasses() {
            const isLabelVisible =  !!this.value || this.focused;
            return [
                'form-field',
                isLabelVisible ? 'form-field--label-visible' : undefined,
            ];
        }
    },
    methods: {
        onFocus() {
            this.focused = true;
        },
        onBlur() {
            this.focused = false;
        },
        clear() {
            this.value = '';
            // this.$emit('input', this.value);
        }

    },
    template: `      
        <div v-bind:class="rootClasses">
             <datetime
                class="form-field__control"
                v-model="value"
                :placeholder="placeholder"
                v-bind="$attrs"
                v-on="$listeners"
            ></datetime>
            <i class="icon icon--remove" style="position: absolute; top: 19px; right: 0; display: block; padding: 11px 15px; cursor: pointer; color: #878787;" @click="clear"></i>
            <label class="form-field__label" v-if="!!placeholder">{{ placeholder }}</label>
        </div>      
    `
};
